module.exports = __webpack_public_path__ + "img/ford.64c62376.png";